import { useEffect } from 'react';

import { useAuth } from '@shared/state/hooks/useAuth';

/**
 * 앱을 열 때 저장된 프로필(localStorage.userProfile)을 서버 값으로 한 번 맞춘다.
 *
 * 프로필은 로그인 때만 저장되고 이후 갱신되지 않는다. 그래서 서버에 새 필드가 생겨도
 * (예: 취약 비밀번호 판정 `security`) 다시 로그인하기 전까지 화면에 반영되지 않았다 —
 * 취약 계정인데 사이드바 배지가 안 뜨던 원인. 토큰이 있을 때 세션당 1회만 auth/me 를 부른다.
 */
let refreshedThisSession = false;

export const useProfileRefreshOnMount = () => {
  const { token, refreshUserProfile } = useAuth();
  useEffect(() => {
    if (!token || refreshedThisSession) return;
    refreshedThisSession = true;
    refreshUserProfile();
    // refreshUserProfile 은 매 렌더 새 함수라 의존성에서 뺀다 (1회 실행이 목적)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);
};
